import * as React from "react";
import { 
    gql, 
    useMutation, 
    ApolloError, 
    MutationTuple 
} from "@apollo/client";
import { 
    ResetMerchantBankPreferenceAdminMutationMutation, ResetMerchantBankPreferenceAdminMutationMutationVariables 
} from "../../../../../schemaTypes";


export const resetMerchantBankPreferenceAdminMutation = gql`
  mutation ResetMerchantBankPreferenceAdminMutation(
    $bankPreferenceId: String!
  ) {
    resetMerchantBankPreferenceAdmin(
      bankPreferenceId: $bankPreferenceId
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export const ResetMerchantBankPreferenceAdminController: React.FC<{ children: (data: {
  resetMerchantBankPreferenceAdmin: MutationTuple<
    ResetMerchantBankPreferenceAdminMutationMutation,
    ResetMerchantBankPreferenceAdminMutationMutationVariables
  >[0];
  loading: boolean;
  error?: ApolloError;
  data?: ResetMerchantBankPreferenceAdminMutationMutation;
  errors?: { path: string; message: string }[] | null;
  message?: string | null;
}) => React.ReactElement | null }> = ({ children }) => {
  const [resetMerchantBankPreferenceAdmin, { loading, error, data }] = useMutation<ResetMerchantBankPreferenceAdminMutationMutation, ResetMerchantBankPreferenceAdminMutationMutationVariables>(resetMerchantBankPreferenceAdminMutation);

  // Extract errors and message from the mutation result, matching resolver response
  const errorsRaw = data?.resetMerchantBankPreferenceAdmin?.errors ?? null;
  const errors = Array.isArray(errorsRaw)
    ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
    : errorsRaw;
  const message = data?.resetMerchantBankPreferenceAdmin?.message ?? null;

  return children({
    resetMerchantBankPreferenceAdmin,
    loading,
    error,
    data: data ?? undefined,
    errors,
    message
  });
};